import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import 'react-quill/dist/quill.snow.css'
import { Button, Flex, Grid, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { ModalLoginBlog } from './ModalLoginBlog'
import { CreateNewPost } from './CreateNewPost'
import { UpdateExistingPost } from './UpdateExistingPost'
import { RegisterNewLink } from './RegisterNewLink'
import { UpdateBannerHome } from './UpdateBannerHome/UpdateBannerHome'
import DraftsList from './DraftsList'
import { toggleShowDrafts, selectDrafts } from '../../../redux/features/drafts/draftSlice'
import { useDispatch, useSelector } from 'react-redux'

export function Blog() {
  const [option, setOption] = useState('create')
  const dispatch = useDispatch()

  const drafts = useSelector((state) => state.drafts)

  const [openModalLoginBlog, setOpenModalLoginBlog] = useState(false)
  const initialUserState = localStorage.getItem('userBlog') || null

  const [userBlog, setUserBlog] = useState(initialUserState ? JSON.parse(initialUserState) : null)

  function handleOption(value) {
    setOption(value)
  }

  function handleShowDrafts() {
    dispatch(toggleShowDrafts())
  }
  console.log('v', drafts)

  if (!userBlog) {
    return (
      <Layout>
        <ModalLoginBlog isOpen={openModalLoginBlog} onClose={() => setOpenModalLoginBlog(false)} setUserBlog={setUserBlog} />
        <Flex flexDir="column" align="center" justify="center" h="full">
          <Text fontSize="xl" fontWeight="bold" mb="4">
            Você precisa estar logado para acessar essa página.
          </Text>
          <Button onClick={() => setOpenModalLoginBlog(true)}>Fazer login</Button>
        </Flex>
      </Layout>
    )
  }

  return (
    <>
      <ModalLoginBlog isOpen={openModalLoginBlog} onClose={() => setOpenModalLoginBlog(false)} setUserBlog={setUserBlog} />
      <HeadingPages name="Blog" />
      <Layout>
        <Grid templateColumns="1fr 1fr" gap="4" mb="4" mx="auto" w="full" maxW="1000px">
          <RegisterNewLink userBlog={userBlog} />

          <UpdateBannerHome userBlog={userBlog} />

          <Button colorScheme={option === 'create' ? 'blue' : 'gray'} onClick={() => handleOption('create')}>
            Criar novo post
          </Button>
          <Button colorScheme={option === 'show' ? 'blue' : 'gray'} onClick={() => handleOption('show')}>
            Visualizar posts
          </Button>

          <DraftsList />
        </Grid>

        {option === 'create' && <CreateNewPost userBlog={userBlog} setOpenModalLoginBlog={setOpenModalLoginBlog} />}

        {option === 'show' && <UpdateExistingPost userBlog={userBlog} setOpenModalLoginBlog={setOpenModalLoginBlog} />}
      </Layout>
    </>
  )
}
